import script from "./PresentasiPjoNC.vue?vue&type=script&setup=true&lang=js"
export * from "./PresentasiPjoNC.vue?vue&type=script&setup=true&lang=js"

import "./PresentasiPjoNC.vue?vue&type=style&index=0&id=6858039c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6858039c"]])

export default __exports__